import type { ParserOptions } from '@json2csv/plainjs';
import { Parser } from '@json2csv/plainjs';
import moment from 'moment';
import type { Types as IdunSoftTypes } from '../types';
import type { CoreTypes } from '../../core';
import { getDayIndex } from '../../core/util';
import { isMongooseObjectId } from '../../common/functions';

const days      = ['måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag'];
const fields    = ['Veckodag', 'Starttid', 'Sluttid', 'Klass', 'Ämne', 'Kommentar', 'Lärare', 'Klassrum', 'Halvklass'];
const delimiter = '\t';
const quote     = '';

export default (courseEvents: CoreTypes.Mixed.Event[]): string => {
  const events = courseEvents
    .map(event => {
      if (event.parked) return;
      if (!event.start || !event.end) return;

      const day = days.at(getDayIndex(event.start));
      if (!day) throw new Error('Invalid event day');

      const course = event.course;
      if (!course || typeof course == 'string' || isMongooseObjectId(course))
        throw new Error('Event course not found or invalid');

      const teachers = (event.teachers ?? course.teachers)?.map(x => x.to);
      const groups   = (event.groups   ?? course.groups  )?.map(x => x.to);

      const doc: IdunSoftTypes.toEvent = {
        Ämne:      course.ids,
        Veckodag:  day,
        Starttid:  moment.utc(event.start).format('HH.mm:ss'),
        Sluttid:   moment.utc(event.end  ).format('HH.mm:ss'),
        Lärare:    (teachers          ?? []).map(x =>      typeof x == 'object' && 'ids' in x ? x.ids : null).filter(x => x != null).join(','),
        Klass:     (groups            ?? []).map(x =>      typeof x == 'object' && 'ids' in x ? x.ids : null).filter(x => x != null).join(','),
        Klassrum:  (event.inLocations ?? []).map(x => x && typeof x == 'object' && 'ids' in x ? x.ids : null).filter(x => x != null).join(','),
        Halvklass: 'Nej'
      };
      return doc;
    })
    .filter(x => x != null);

  const opts: ParserOptions<IdunSoftTypes.toEvent> = { fields, delimiter/* , quote */ };
  const parser = new Parser(opts);
  return parser.parse(events);
};
